import { render } from "./PaypalCard.vue?vue&type=template&id=52af4810"
import script from "./PaypalCard.vue?vue&type=script&lang=js"
export * from "./PaypalCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__